import { hexToRgba } from "@/lib/hexToRgba";
import { motion } from "framer-motion";
import Image from "next/image";
import React, { Dispatch, SetStateAction } from "react";

interface props {
  setData: Dispatch<SetStateAction<Record<string, string | number>>>;
  dataKey: "string";
  options?: { option: string; mark: number | string }[];
  data: Record<string, string | number>;
  theme: string[];
}

const SingleSelectPillInput = ({
  options,
  theme,
  data,
  setData,
  dataKey,
}: props) => {
  const handleClick = (val) => {
    // localStorage.setItem('bioFormData', JSON.stringify({ ...p, [dataKey]: val }));
    // setData(p => ({ ...p, [dataKey]: val }))
    setData((p) => {
      localStorage.setItem(
        "bioFormData",
        JSON.stringify({ ...p, [dataKey]: val })
      );
      return { ...p, [dataKey]: val };
    });
  };
  return (
    <div className="flex flex-col gap-4 w-full">
      {options?.map((option, idx) => {
        const isSelected = data[dataKey] === option?.option;
        return (
          <motion.div
            onClick={() => handleClick(option.option)}
            key={option.option}
            style={{
              backgroundColor: isSelected ? theme[0] : hexToRgba(theme[0], 0.2),
              fontWeight: isSelected ? "bold" : "normal",
              color: isSelected ? "white" : "black",
            }}
            className="flex gap-4  justify-between cursor-pointer p-2 border-black rounded-lg text-black items-center "
          >
            <div className="flex items-center gap-4">{option.option}</div>
            <Image
              style={{}}
              src={
                isSelected
                  ? "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Select.svg"
                  : "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Add.svg"
              }
              height={24}
              width={24}
              alt="icon"
            ></Image>
          </motion.div>
        );
      })}
    </div>
  );
};

export default SingleSelectPillInput;
